module.exports = __webpack_public_path__ + "img/pic05.3201db81.jpg";